import { _js } from '@ifixit/localize';

export function About({ userid: _userid, data }: { userid: number; data: any }) {
   const wiki = data.about;

   return (
      <div className="flex flex-col items-start max-w-[646px] gap-6">
         <h2 className="heading-30">{_js('About')}</h2>
         {wiki && <UserWiki data={wiki} />}
      </div>
   );
}

const UserWiki = ({ data }: { data: any }) => (
   <div
      className="renderedText w-full max-m:max-w-[100vw]"
      dangerouslySetInnerHTML={{ __html: data }}
   />
);
